import { useTranslation } from "react-i18next";

import { TarifBarHeadline } from "./TarifBarHeadline";

export const RoamingCallExplanation = ({ title }: { title?: string }) => {
  const { t } = useTranslation("portal");

  return (
    <TarifBarHeadline
      title={title}
      tooltipContent={
        <>
          <h3 className="mb-1 block font-semibold">
            {t("cockpit.managementTile.roaming.roamingCallHint.title")}
          </h3>
          <p>{t("cockpit.managementTile.roaming.roamingCallHint.text")}</p>
        </>
      }
    />
  );
};
